module.exports = __webpack_public_path__ + "img/f4bcf6d.png";